import React from 'react'
import { Question, QuestionFrameContext, RadioItems } from 'components/questions'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { useGlobalState } from 'state'
import { RadioItem } from 'common/types'


type RadioQuestionProps = {
  num: number
  content: string
  items: RadioItem[]
  row?: boolean
  visibleRaidoGroup?: boolean
}

export const RadioQuestion = ({ num, content, items, row = false, visibleRaidoGroup = true, children }: React.PropsWithChildren<RadioQuestionProps>) => {
  const state = useGlobalState()
  const q = React.useContext(QuestionFrameContext)

  const value: string = React.useMemo(() => {
    const answer = state.app.getAnswer(q, num)
    return answer !== null ? answer.value : ''
  }, [state.app.answers])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const targetValue = (event.target as HTMLInputElement).value
    state.app.updateAnswer(q, num, targetValue)
  }

  return (
    <Question num={num} content={content}>
      { visibleRaidoGroup &&
        <RadioGroup row={row} value={value} onChange={handleChange}>
          <RadioItems items={items} />
        </RadioGroup>
      }
      {children}
    </Question>
  )
}
